module.exports = __webpack_public_path__ + "static/media/split.57d40f20.png";